import React from 'react';
import styled from 'styled-components';

import { colors, Quote } from '../ui-components';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} node rich-text node
 * @param {element} children collection of child rich-text nodes
 */
const RichQuote = (node, children) => <StyledQuote>{children}</StyledQuote>;

const StyledQuote = styled(props => <Quote {...props} />)`
  &:before,
  &:after {
    content: '';
  }

  p {
    padding-left: 24px;
    position: relative;
  }

  p:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 4px;
    background-color: ${colors.crederaRed};
  }
`;

export default RichQuote;
